import { FC } from 'react';
import { Center, Image } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import CompanyLogo from 'components/CompanyLogo';

import logoUploadBanner from '../../../../assets/logo-upload-banner.png';
import logoUploadErrorBannerImg from '../../../../assets/logo-upload-error-banner.png';

/**
 * Custom value derived from logoUploadBanner display dimensions
 * Ensures the component's dimensions stay constant
 */
const CONTAINER_HEIGHT = '180px';

interface PreviewImageProps {
  logoUrl?: string;
  isError?: boolean;
}

const PreviewImage: FC<PreviewImageProps> = ({ isError, logoUrl }) => {
  if (isError) {
    return (
      <Image
        alt=""
        height={CONTAINER_HEIGHT}
        role="presentation"
        src={logoUploadErrorBannerImg}
      />
    );
  }

  if (!logoUrl) {
    return (
      <Image
        alt=""
        height={CONTAINER_HEIGHT}
        role="presentation"
        src={logoUploadBanner}
      />
    );
  }

  return (
    <Center
      backgroundColor="grey.300"
      height={CONTAINER_HEIGHT}
      marginBottom="space-24"
    >
      <Center
        backgroundColor="white"
        height={80} // Matches lg size CompanyLogo
        outline="2px dashed"
        outlineColor="black"
        width={160} // Matches lg size CompanyLogo
      >
        {logoUrl && !isError ? (
          <CompanyLogo logoUrl={logoUrl} size="lg" />
        ) : (
          <SunshineIcon color="red.-1" name="cross-file" size="icon-56" />
        )}
      </Center>
    </Center>
  );
};

export default PreviewImage;
